/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CustomColumnRepresentationFromJSON, CustomColumnRepresentationToJSON, InheritedAccountTagFromJSON, InheritedAccountTagToJSON, InheritedDimensionTagFromJSON, InheritedDimensionTagToJSON, SheetRowPredicateRepresentationFromJSON, SheetRowPredicateRepresentationToJSON, } from './';
export function SearchSheetRowSearchResultElementRepresentationFromJSON(json) {
    return SearchSheetRowSearchResultElementRepresentationFromJSONTyped(json, false);
}
export function SearchSheetRowSearchResultElementRepresentationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        path: json['path'],
        id: json['id'],
        parentId: json['parentId'],
        name: json['name'],
        accountTagId: json['accountTagId'],
        dimensionTagIds: json['dimensionTagIds'],
        tableTagId: json['tableTagId'],
        predicate: json['predicate'] === null
            ? null
            : json['predicate'].map(SheetRowPredicateRepresentationFromJSON),
        customColumns: json['customColumns'].map(CustomColumnRepresentationFromJSON),
        readonly: json['readonly'],
        withData: json['withData'],
        hierarchyFlatten: json['hierarchyFlatten'],
        hierarchyMaxDepth: json['hierarchyMaxDepth'],
        order: !exists(json, 'order') ? undefined : json['order'],
        inheritedAccountTags: json['inheritedAccountTags'].map(InheritedAccountTagFromJSON),
        inheritedDimensionTags: json['inheritedDimensionTags'].map(InheritedDimensionTagFromJSON),
        generated: json['generated'],
        hasChildren: json['hasChildren'],
    };
}
export function SearchSheetRowSearchResultElementRepresentationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        path: value.path,
        id: value.id,
        parentId: value.parentId,
        name: value.name,
        accountTagId: value.accountTagId,
        dimensionTagIds: value.dimensionTagIds,
        tableTagId: value.tableTagId,
        predicate: value.predicate === null
            ? null
            : value.predicate.map(SheetRowPredicateRepresentationToJSON),
        customColumns: value.customColumns.map(CustomColumnRepresentationToJSON),
        readonly: value.readonly,
        withData: value.withData,
        hierarchyFlatten: value.hierarchyFlatten,
        hierarchyMaxDepth: value.hierarchyMaxDepth,
        order: value.order,
        inheritedAccountTags: value.inheritedAccountTags.map(InheritedAccountTagToJSON),
        inheritedDimensionTags: value.inheritedDimensionTags.map(InheritedDimensionTagToJSON),
        generated: value.generated,
        hasChildren: value.hasChildren,
    };
}
